(() => {
  const lockedSelector = '[data-first-look-locked="true"]';
  const checkInterval = 15000;
  const pacificClock = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hourCycle: 'h23',
  });

  function getPacificTimeParts() {
    return Object.fromEntries(
      pacificClock
        .formatToParts(new Date())
        .filter((part) => part.type !== 'literal')
        .map((part) => [part.type, part.value])
    );
  }

  function refreshWhenReleased() {
    const lockedItems = [...document.querySelectorAll(lockedSelector)];
    if (!lockedItems.length) return;

    const time = getPacificTimeParts();
    const hasSaturdayTest = lockedItems.some((item) => item.dataset.firstLookTest === 'true');
    const isSaturdayTestRelease = hasSaturdayTest && time.weekday === 'Sat' && Number(time.hour) >= 15;
    const isSundayRelease = time.weekday === 'Sun' && Number(time.hour) >= 17;
    const isReleaseWindow = isSaturdayTestRelease || isSundayRelease;

    if (isReleaseWindow) {
      const releaseDate = `${time.year}-${time.month}-${time.day}`;
      const refreshKey = `kings-first-look-refreshed-${releaseDate}`;

      if (!sessionStorage.getItem(refreshKey)) {
        sessionStorage.setItem(refreshKey, 'true');
        window.location.reload();
      }
      return;
    }

    window.setTimeout(refreshWhenReleased, checkInterval);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshWhenReleased, { once: true });
  } else {
    refreshWhenReleased();
  }
})();
